// Collection View Switcher
document.addEventListener('DOMContentLoaded', function() {
  // Get view toggle buttons
  const gridViewButton = document.getElementById('col_2');
  const tableViewButton = document.getElementById('col_table');
  
  // Get view containers
  const productGrid = document.getElementById('product-grid');
  const tableContainer = document.getElementById('product-table-container');
  
  // Initialize view (get from localStorage or default to grid)
  let currentView = localStorage.getItem('collection_view') || 'grid';
  
  // Make sure we have a valid view option (in case previously saved 'list' which is now removed)
  if (currentView !== 'grid' && currentView !== 'table') {
    currentView = 'grid';
  }
  
  setActiveView(currentView);
  
  // Setup event listeners
  if (gridViewButton) {
    gridViewButton.addEventListener('click', function(e) {
      e.preventDefault();
      setActiveView('grid');
    });
  }
  
  if (tableViewButton) {
    tableViewButton.addEventListener('click', function(e) {
      e.preventDefault();
      setActiveView('table');
    });
  }
  
  // Function to set active view
  function setActiveView(view) {
    // Save to localStorage
    localStorage.setItem('collection_view', view);
    
    // Remove active class from all buttons
    if (gridViewButton) gridViewButton.classList.remove('active');
    if (tableViewButton) tableViewButton.classList.remove('active');
    
    // Set appropriate displays and active classes
    switch (view) {
      case 'grid':
        if (productGrid) {
          // Don't change the display style for the grid - it could be using flex or other display settings
          // Just make sure it's visible and not modified
          productGrid.style.removeProperty('display');
          // Make sure the default classes are preserved
          tableContainer.style.display = 'none';
          gridViewButton.classList.add('active');
        }
        break;
        
      case 'table':
        if (productGrid && tableContainer) {
          productGrid.style.display = 'none';
          tableContainer.style.display = 'block';
          tableViewButton.classList.add('active');
        }
        break;
    }
  }
});
